import { divide } from "lodash";
import React, { Component } from "react";
import { Divider } from "semantic-ui-react";
import { Segment, Button, Icon, Table, Select, Form, Tab, Message, Pagination, Input, Modal, List } from 'semantic-ui-react'
import config from "../config";
import  { invokeApig } from "../libs/awsLib";
import { JSONDate, lookupDescription, formatDateTime } from "../libs/sharedFunctions";
import ReactJson from 'react-json-view'
import { Link} from "react-router-dom";


export default class SmartOrchestration extends Component {
  constructor(props) {
    super(props);
  
    const today=new Date();
    var startDate=new Date();
    startDate.setDate(today.getDate() - 1)
    var endDate=new Date();

    this.state = {
      orchestration: {id: null}, 
      orchestrationHistory: [], 
      orchestrationDefinition: {}, 
      orchestrationData: {}, 
      eventTriggers: []
        };
  

  
 }
 
loadOrchestration=(orchestrationId)=>
{


  invokeApig({path: "/api/orchestrations/"+orchestrationId, method: "GET"}).then((result)=>
  {
    this.setState({orchestration: result.data})
  });
}

loadOrchestrationHistory=(orchestrationId)=>
{

  invokeApig({path: "/api/orchestrations/"+orchestrationId+'/orchestrationresponses', method: "GET"}).then((result)=>
  {
    this.setState({orchestrationHistory: result.data})
  });
}

loadEventTriggers=(orchestrationId)=>
{
  var queryParams=['orchestrationid='+orchestrationId];
  invokeApig({path: "/api/eventtriggers", method: "GET", queryParams: queryParams}).then((result)=>
  {
    this.setState({eventTriggers: result.data})
  });
}

getOrchestrationData=(fieldName)=>{
  if (fieldName in this.state.orchestrationData)
    return this.state.orchestrationData[fieldName]
}

setOrchestrationData=(fieldName, value)=>{
  var newData=Object.assign({}, this.state.orchestrationData)
  newData[fieldName]=value;
  this.setState({orchestrationData: newData})
}

componentDidMount()
{
    this.loadOrchestration(this.props.orchestrationid);
    this.loadOrchestrationHistory(this.props.orchestrationid);
    this.loadEventTriggers(this.props.orchestrationid);
}

componentWillReceiveProps(nextProps)
{
  if (this.props.orchestrationid!==nextProps.orchestrationid)
  {
    this.loadOrchestration(nextProps.orchestrationid);
    this.loadOrchestrationHistory(nextProps.orchestrationid);
    this.loadEventTriggers(nextProps.orchestrationid);

  }
}

renderOrchestrationStep(stepkey, step)
{

  const response=this.state.orchestrationHistory.find(event=>{return event.orchestrationstep===stepkey && (event.responsedata.status==="Success" || event.responsedata.status==="Error")});
  console.log(this.state.orchestrationHistory, stepkey, response)
  if (response)
  {
  //completed
    if (response.responsedata.status==="Success")
      return <List.Item><List.Icon name='check'/><List.Content><List.Header>Step {stepkey}: {step.description}</List.Header><List.Description>Completed at {formatDateTime(new Date(response.datetime))}</List.Description></List.Content></List.Item>
    else 
      return <List.Item><List.Icon name='x'/><List.Content><List.Header>Step {stepkey}: {step.description}</List.Header></List.Content></List.Item>
    }
    else if (this.state.eventTriggers.filter(event=>{return event.orchestrationstep===stepkey}).length>0)
      //waiting
      return <List.Item><List.Icon name='clock'/><List.Content><List.Header>Step {stepkey}: {step.description}</List.Header><List.Description>Waiting for response</List.Description></List.Content></List.Item>
  }

  render() {
    const viewPanes = [
      { menuItem: {key: 'Status', content: 'Status', icon: 'list'}, render: () => 
      <Tab.Pane>
        <List>
          {Object.keys(this.props.definition.steps).map(stepkey=>{
          const step=this.props.definition.steps[stepkey];
          return this.renderOrchestrationStep(stepkey, step)
            })}
        </List>
    </Tab.Pane> },       
      { menuItem: {key: 'Data', content: 'Data', icon: 'table'}, render: () => 
      <Tab.Pane>
        <ReactJson src={this.state.orchestration.data} name={false} collapsed={false} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />
    </Tab.Pane> }, 
    { menuItem: {key: 'History', content: 'History', icon: 'history'}, render: () => 
    <Tab.Pane>
      <Table>
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        <Table.HeaderCell>Step</Table.HeaderCell>
        <Table.HeaderCell>Description</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Data</Table.HeaderCell>
      </Table.Row>
      </Table.Header>
      <Table.Body>
      {this.state.orchestrationHistory.map(row=>{
        return <Table.Row>
          <Table.Cell>{formatDateTime(new Date(row.datetime))}</Table.Cell>
          <Table.Cell>{row.orchestrationstep}</Table.Cell>
          <Table.Cell>{"description" in row.responsedata ? row.responsedata.description : ''}</Table.Cell>
          <Table.Cell>{"status" in row.responsedata ? row.responsedata.status : ''}</Table.Cell>
          <Table.Cell>{<ReactJson src={row.responsedata} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />}</Table.Cell>
        </Table.Row>
      })}
      </Table.Body>
      </Table>
  </Tab.Pane> }]



        return <Tab menu={{secondary: true, pointing: true  }} panes={viewPanes} />


        }
}